"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeferLiquidityCheckAdapterStorageV2Factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "WETH",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "erc20TokenToTTokenMap",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "flashLoanAndLiquidateSlippageTolerance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "oracles",
        outputs: [
            {
                internalType: "contract IPriceOracle",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tTokenToErc20TokenMap",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "vvs",
        outputs: [
            {
                internalType: "contract IVVSRouter02",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b506101f7806100206000396000f3fe608060405234801561001057600080fd5b50600436106100625760003560e01c806308e77344146100675780638a70e439146100975780638db35baa146100cb578063ad5c4648146100e2578063addd5099146100f5578063c7fb1c721461011e575b600080fd5b60015461007a906001600160a01b031681565b6040516001600160a01b0390911681526020015b60405180910390f35b61007a6100a536600461018f565b60036020908152600092835260408084209091529082529020546001600160a01b031681565b6100d460045481565b60405190815260200161008e565b60005461007a906001600160a01b031681565b61007a61010336600461016e565b6002602052600090815260409020546001600160a01b031681565b61007a61012c36600461018f565b60056020908152600092835260408084209091529082529020546001600160a01b031681565b80356001600160a01b038116811461016957600080fd5b919050565b60006020828403121561017f578081fd5b61018882610152565b9392505050565b600080604083850312156101a1578081fd5b6101aa83610152565b91506101b860208401610152565b9050925092905056fea2646970667358221220a71cc02654ca4efd4ffd7a745b801456f575b435b8278d1695b10a6ef4a52ea964736f6c63430008030033";
class DeferLiquidityCheckAdapterStorageV2Factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.DeferLiquidityCheckAdapterStorageV2Factory = DeferLiquidityCheckAdapterStorageV2Factory;
DeferLiquidityCheckAdapterStorageV2Factory.bytecode = _bytecode;
DeferLiquidityCheckAdapterStorageV2Factory.abi = _abi;
//# sourceMappingURL=DeferLiquidityCheckAdapterStorageV2Factory.js.map